import FormField from 'components/FormField';
import { FV } from './share';
import { DisabledProps } from 'views/Aide/Scenario/TaskForm/share';
import FRadioGroup from 'components/FRadioGroup';
import { useTranslate } from '@tolgee/react';
import { useMemo } from 'react';
import { useFormikContext } from 'formik';

function DiscountType({ disabled }: DisabledProps) {
  const { t, discountTypeLabel } = useDiscountTypeLabel();

  const { setValues } = useFormikContext<FV>();

  return (
    <FormField<FV['discountType']> name="discountType" required label={t('form.discountType')}>
      {({ field: { value } }) => {
        return (
          <FRadioGroup
            disabled={disabled}
            value={value}
            onChange={(value) => {
              setValues((values) => ({
                ...values,
                discountType: value as any,
                discountValue: undefined,
              }));
            }}
            options={Object.keys(discountTypeLabel).map((key) => ({
              value: key,
              label: discountTypeLabel[key],
            }))}
          />
        );
      }}
    </FormField>
  );
}

export function useDiscountTypeLabel() {
  const { t } = useTranslate();

  return {
    t,
    discountTypeLabel: useMemo(() => {
      return {
        PERCENT: t('form.discount'),
        AMOUNT: t('form.discountAmount'),
      };
    }, [t]),
  };
}

export default DiscountType;
